import React from "react";
import styles from "./Alert.module.scss";

export default function Alert({children, showShadow = true, variant = "none", className = "", ...rest}) {
  return (
    <div
      variant={variant}
      className={`${styles.alert} ${showShadow ? styles.shadow : ""} ${className}`}
      aria-label="alert"
      role="alert"
      {...rest}>
      {children}
    </div>
  );
}
